import { styled } from '@thg-commerce/gravity-theme'

import { CustomDropdown } from '../CustomDropdown'

export const StyledDropdown = styled(CustomDropdown)`
  width: 100%;
`
